const ITEMS = [
  'Two days a week, back to you',
  'Reads Facebook Ads',
  'Tracks Stripe MRR',
  'Morning briefings',
  'Five voices, your pick',
  'A private line, just for you',
  'Live data, on demand',
  'No dashboards to dig through',
  'Per-tenant isolated',
  'Azure-hosted',
  'Plain English',
]

export default function LandingMarquee() {
  // Duplicate the items so the marquee loops seamlessly
  const loop = [...ITEMS, ...ITEMS]
  return (
    <div className="lp-marquee" aria-hidden="true">
      <div className="lp-marquee-track">
        {loop.map((item, i) => (
          <span className="lp-marquee-item" key={`${item}-${i}`}>
            <span className="lp-dot" />
            {item}
          </span>
        ))}
      </div>
    </div>
  )
}
